import { html, View } from 'rune-ts';
import klass from './BottomTabBar.module.scss';
import { typo } from '../../../../shared/typography/typo';
import {
  HomeFillIcon,
  PopupStoreIcon,
  ExploreFillIcon,
  realtimeRankingFillIcon,
  UserFillIcon,
} from '../../atoms/Icon';
import { htmlIf } from '../../../../shared/util';
import { GNB_MAP } from '@services/MarppleShop/renderApp/components/cells/Header/libs/contants/menu.ts';

export interface BottomTabBarData {
  selected_tab_idx: number;
  is_logged_in: boolean;
}

interface BottomTabBarOption {
  klass?: string;
}

export class BottomTabBar extends View<BottomTabBarData> {
  state: BottomTabBarOption & {
    // FIXME
  };

  static getHeight() {
    return 62;
  }

  constructor(data: BottomTabBarData, option: BottomTabBarOption = {}) {
    super(data);

    this.state = {
      klass: option.klass,
    };
  }

  override template() {
    const { selected_tab_idx, is_logged_in } = this.data;
    const getClassWhenSelected = (idx: number) => htmlIf(klass.selected, selected_tab_idx == idx);
    return html`<div class="${this.state.klass} ${klass.bottom_tab_bar} ${typo('10_medium')}">
      <div class="${klass.tab_container}">
        <a href="/${ET.lang}/" class="${klass.tab} ${getClassWhenSelected(0)}">
          <span class="${klass.icon}">${HomeFillIcon}</span>
          <span>${ET('mps2::gnb::menu::home')}</span>
        </a>
        <a href="${GNB_MAP.REALTIME.url}" class="${klass.tab} ${getClassWhenSelected(1)}">
          <span class="${klass.icon}">${realtimeRankingFillIcon}</span>
          <span>${ET(GNB_MAP.REALTIME.bottom_tab_bar_name || GNB_MAP.REALTIME.name)}</span>
        </a>
        <a href="${GNB_MAP.POPUP.url}" class="${klass.tab} ${getClassWhenSelected(2)}">
          <span class="${klass.icon}">${PopupStoreIcon}</span>
          <span>${ET(GNB_MAP.POPUP.name)}</span>
        </a>
        <a href="${GNB_MAP.EXPLORE.url}" class="${klass.tab} ${getClassWhenSelected(3)}">
          <span class="${klass.icon}">${ExploreFillIcon}</span>
          <span>${ET(GNB_MAP.EXPLORE.name)}</span>
        </a>
        <a href="/${ET.lang}/@/mypage" class="${klass.tab} ${getClassWhenSelected(4)}">
          <span class="${klass.icon}">${UserFillIcon}</span>
          <span>${is_logged_in ? ET('mps2::gnb::menu::mypage') : ET('mps2::login::login')}</span>
        </a>
      </div>
    </div> `;
  }
}
